import { HomePage } from "../pages/HomePage";
import { StudentStatusQuery } from "../pages/StudentStatusQuery";
import { ArchiveIndex } from "../pages/archive";
import { Gdjy } from "../pages/archive/Content/Gdjy";
import { GdjyDetail } from "../pages/archive/Content/GdjyDetail";
import { GdjyDetailTwo } from "../pages/archive/Content/GdjyDetailTwo";
import { GdjyDetailXW } from "../pages/archive/Content/GdjyDetailXW";
import { ReportBox } from "../pages/archive/Content/ReportBox";
import { Gaokao } from "../pages/archive/Content/Gaokao";
import { ReportXjBox } from "../pages/archive/Content/ReportXjBox";
import { ReportXwBox } from "../pages/archive/Content/ReportXwBox";
import { Scattered } from "../pages/archive/Content/Scattered";
import { College } from "../pages/archive/Content/College";
import { Verify } from "../pages/Verify";
import { Query } from "../pages/Query";
import Login from "../pages/Login";
import { GdjyDetailThree } from "../pages/archive/Content/GdjyDetailThree";
import { GdjyxjDetailThree } from "../pages/archive/Content/GdjyxjDetailThree";
import { ReportIndex } from "../pages/archive/Content/ReportIndex";
// import { Xuelidown } from "../pages/archive/Content/Xuelidown";
import Xuelidown from "../pages/archive/Content/Xuelidown/Xuelidown.jsx";
const route = [
	{ path: "/", name: "首页", components: HomePage },
	{ path: "/index", name: "首页", components: HomePage },
	{ path: "/statusQuery", name: "学籍查询", components: StudentStatusQuery },
	{ path: "/archiveIndex", name: "学籍查询", components: ArchiveIndex },
	{ path: "/login", name: "登录_学信档案", components: Login },
	{ path: "/active/gdjy", name: "高等教育", components: Gdjy },
	{ path: "/gdjy/detail", name: "高等教育学籍详情-1", components: GdjyDetail },
	{ path: "/gdjy/detail/threexj", name: "高等教育学籍学位-3", components: GdjyxjDetailThree },
	
	{ path: "/gdjy/detail/two", name: "高等教育学籍详情-2", components: GdjyDetailTwo },
	{ path: "/gdjy/detail/three", name: "高等教育学籍详情-3", components: GdjyDetailThree },
	{ path: "/gdjy/detail/xw", name: "高等教育学籍学位", components: GdjyDetailXW },
	{ path: "/gdjy/ReportBox", name: "学历报告", components: ReportBox },
	{ path: "/gdjy/Gaokao", name: "高考成绩", components: Gaokao },
	{ path: "/gdjy/ReportXwBox", name: "学历报告", components: ReportXwBox },
	{ path: "/gdjy/ReportXjBox", name: "学历报告", components: ReportXjBox },
	{ path: "/Verify", name: "查询", components: Verify },
	{ path: "/Query", name: "验证", components: Query },
	{ path: "/Scattered", name: "零散查询", components: Scattered },
	{ path: "/College", name: "高考成绩查询", components: College },
	{ path: "/gdjy/ReportIndex", name: "查看报告", components: ReportIndex },
	{ path: "/report/Xuelidown", name: "下载报告", components: Xuelidown },
	
	// { path: "/login", name: "登录_学信档案", components: Login },
];

export const routers = [...route];
